import * as React from 'react';

import './styles/WizardHeader.scss';

type Props = {
  children: React.ReactNode;
};

export default function WizardHeader(props: Props) {
  return <header className="WizardHeader">{props.children}</header>;
}
